import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const experiences = [{
  id: "gastronomic-journey",
  title: "Gastronomic Journey",
  description: "Savor the finest local ingredients prepared by Michelin-starred chefs in an intimate, private setting.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gastronomic_journey.png",
  imageSrcSet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gastronomic_journey.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gastronomic_journey.png-wvc-sizes",
  imageAlt: "Private dining experience with exquisite culinary presentation",
  link: "/experiences/gastronomy",
  colSpan: "md:col-span-7",
  offset: ""
}, {
  id: "art-scene",
  title: "Art Scene",
  description: "Exclusive after-hours access to premier galleries, guided by renowned local curators and artists.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/art_scene.png",
  imageSrcSet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/art_scene.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/art_scene.png-wvc-sizes",
  imageAlt: "Exclusive gallery tour with curated artworks",
  link: "/experiences/art",
  colSpan: "md:col-span-5",
  offset: "md:translate-y-10"
}, {
  id: "breathe-and-bloom",
  title: "Breathe and Bloom",
  description: "Rejuvenate your senses with bespoke wellness retreats hidden away in serene, untouched landscapes.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/breathe_and_bloom.png",
  imageSrcSet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/breathe_and_bloom.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/breathe_and_bloom.png-wvc-sizes",
  imageAlt: "Serene wellness retreat in nature",
  link: "/experiences/wellness",
  colSpan: "md:col-span-5",
  offset: ""
}, {
  id: "wilderness-elegance",
  title: "Wilderness Elegance",
  description: "Experience the thrill of the wild without compromising on unparalleled luxury and comfort.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/wilderness_elegance.png",
  imageSrcSet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/wilderness_elegance.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/wilderness_elegance.png-wvc-sizes",
  imageAlt: "Luxury wilderness camp under the stars",
  link: "/experiences/adventure",
  colSpan: "md:col-span-7",
  offset: ""
}];
export default function ExclusiveExperiences() {
  return <section id="exclusive-experiences" className="bg-background py-[160px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="mb-16 md:mb-24 text-center md:text-left">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
            Exclusive Experiences
          </h2>
          <p className="font-sans text-lg text-muted-foreground max-w-2xl">
            Curated moments designed to inspire and transform. Discover our handpicked selection of extraordinary journeys.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 lg:gap-12">
          {experiences.map((exp, i) => <div key={exp.id} data-index={i} className={`${exp.colSpan} ${exp.offset}`}>
              <Link to={exp.link} className="block h-full group outline-none">
                <Card className="dark bg-card text-card-foreground border-none h-full overflow-hidden transition-all duration-500 group-hover:ring-2 group-hover:ring-primary group-hover:shadow-2xl group-hover:shadow-primary/20 rounded-xl">
                  <div className="overflow-hidden">
                    <AspectRatio ratio={16 / 10} className="bg-muted">
                      <img src={exp.imageSrc} data-wvc-srcset={exp.imageSrcSet} data-wvc-sizes={exp.imageSizes} alt={exp.imageAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </AspectRatio>
                  </div>
                  <CardHeader className="pt-8 pb-4 px-8">
                    <CardTitle className="font-default font-semibold text-3xl md:text-4xl text-secondary tracking-wide">
                      {exp.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-8 flex flex-col justify-between flex-grow">
                    <CardDescription className="font-sans text-base md:text-lg text-card-foreground/90 leading-relaxed mb-8">
                      {exp.description}
                    </CardDescription>
                    <div className="mt-auto">
                      <Button variant="ghost" className="p-0 h-auto text-primary hover:text-primary hover:bg-transparent group/btn font-sans text-sm tracking-wider uppercase">
                        Discover More
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}